module.exports = __webpack_public_path__ + "42a011b48ca12008cb8aa78501a5bd26.MP3";